import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

const STORAGE_KEY = 'locale-recommendation-snoozed';

/**
 * Hides the dashboard's language recommendation until the next sign-in, with nothing sent to the
 * server. The session calls `reset` at each sign-in; a token renewal is not one.
 */
export default class LocaleRecommendationSnoozeService extends Service {
  @tracked isSnoozed = readStored();

  /** Resolves at once: the item leaves even when storage refuses the write. */
  snooze = async () => {
    this.isSnoozed = true;
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // Storage refused: the item stays hidden until the page reloads.
    }
  };

  reset = () => {
    this.isSnoozed = false;
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // Storage refused the snooze too, so nothing is stored.
    }
  };
}

function readStored() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

declare module '@ember/service' {
  interface Registry {
    'locale-recommendation-snooze': LocaleRecommendationSnoozeService;
  }
}
